module.exports = __webpack_public_path__ + "@/assets/img/work_step_2.26bd2838.png";